module.exports = __webpack_public_path__ + "img/yyzdw.80cf7610.png";